import styled from '@emotion/styled';
import Box from '@mui/system/Box';

export const SchedulingWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;

  nylas-scheduling::part(nse__close-button) {
    display: none;
    border: 1px solid blue;
  }

  nylas-scheduling::part(nls__language) {
    display: none;
  }
`;
